export const sevenImperatives = [
  {
    id: '1',
    name: 'Who is the Buyer?',
    summaryQuestion: 'List the buyer',
    tasks: [
      {
        id: '111',
        imperative: '1',
        text: 'Buyer confirmed?'
      },{
        id: '112',
        imperative: '1',
        text: 'Organizational needs and objectives confirmed?'
      },{
        id: '113',
        imperative: '1',
        text: 'Budget confirmed?'
      },{
        id: '114',
        imperative: '1',
        text: 'Buyer can enthusiastically sell our Value Proposition'
      },{
        id: '115',
        imperative: '1',
        text: 'Do you have access to the Buyer?'
      }
    ],
    questions: [
      {
        id: '121',
        text: 'How will you be measured on this initiative?',
      },{
        id: '122',
        text: 'What would success look like on this initiative?',
      },{
        id: '123',
        text: 'Could explain the procurement process at your company? Who needs to have input on this initiative? Who will ultimately sign this contract?',
      },{
        id: '124',
        text: 'Review publicly available data to review executive names?',
      }
    ]
  },{
    id: '2',
    name: 'Who are the Influencers?',
    summaryQuestion: 'List all influencers',
    tasks: [
      {
        id: '211',
        imperative: '2',
        text: 'All Influencers confirmed?'
      },{
        id: '212',
        imperative: '2',
        text: 'Do we have access to all Influencers?'
      },{
        id: '213',
        imperative: '2',
        text: 'Influencers are aligned on business goals and objectives?'
      },{
        id: '214',
        imperative: '2',
        text: 'All Influencers can enthusiastically support our Value Proposition?'
      },{
        id: '215',
        imperative: '2',
        text: 'Has one or more of the Influencers become an advisor?'
      }
    ],
    questions: [
      {
        id: '221',
        text: 'Can you explain the buying or procurement process at your company?',
      },{
        id: '222',
        text: 'With clients of similar complexity we typically have discovery calls with the head of IT, HR, Operations etc... can you help make those connections?',
      },{
        id: '223',
        text: 'This initiative cuts across various departments, how can I help you communicate the goals, objectives and ROI to your colleagues?',
      }
    ]
  },{
    id: '3',
    name: 'Who are we competing against, and why?',
    summaryQuestion: 'Summarize strategy',
    tasks: [{
      id: '311',
      imperative: '3',
      text: 'I know who our competition is?',
    },{
      id: '312',
      imperative: '3',
      text: 'Buyer has shared their perception of competition?',
    },{
      id: '313',
      imperative: '3',
      text: 'Competition has an existing relationship with Prospect?',
    },{
      id: '314',
      imperative: '3',
      text: 'I understand why each Competitor is at the table?',
    },{
      id: '315',
      imperative: '3',
      text: 'Buyer and Influencers are aligned on most important Partner attributes?',
    }],
    questions: [{
      id: '321',
      text: 'What other potential solutions to this opportunity/problem is your company considering? Have you outlined the pros and cons of each alternative?',
    },{
      id: '322',
      text: 'What functionality or features have you seen in the marketplace that you are impressed with?',
    },{
      id: '323',
      text: 'Who do you currently consider to be your top partner/vendor? Why?',
    }]
  },{
    id: '4',
    name: 'Why will we win?',
    summaryQuestion: 'Summarize strategy',
    tasks: [{
      id: '411',
      imperative: '4',
      text: 'I clearly understand prospect’s needs and objectives?',
    },{
      id: '412',
      imperative: '4',
      text: 'Prospect has shared Organizational Pain Points?',
    },{
      id: '413',
      imperative: '4',
      text: 'Prospect is advising me on a Win Strategy?',
    },{
      id: '414',
      imperative: '4',
      text: 'I understand our position against our Competitors?',
    },{
      id: '415',
      imperative: '4',
      text: 'Prospect has shared decision making/procurement process?',
    }],
    questions: [{
      id: '421',
      text: 'How will you be measured on this initiative?',
    },{
      id: '422',
      text: 'What does success look like on this project?',
    },{
      id: '423',
      text: 'Do you have all the information you need from us to  confidently support this decision?',
    }]
  },{
    id: '5',
    name: 'Why will we lose?',
    summaryQuestion: 'Summarize risks',
    tasks: [{
      id: '511',
      imperative: '5',
      text: 'I can outline all risks on this opportunity?',
    },{
      id: '512',
      imperative: '5',
      text: 'I have a clear follow up plan to overcome all risks?',
    },{
      id: '513',
      imperative: '5',
      text: 'Buyer is sharing internal objections?',
    },{
      id: '514',
      imperative: '5',
      text: 'We have reviewed Terms and Conditions and believe there are no deal breakers?',
    },{
      id: '515',
      imperative: '5',
      text: 'Buyer is being transparent about our position?',
    }],
    questions: [{
      id: '521',
      text: 'Are all key business influencers aligned on this decision? If not, how can we help get them there?',
    },{
      id: '522',
      text: 'Is there anything about our value proposition that we have worked on together that doesn’t solve your problems or that you are unsure of?',
    },{
      id: '523',
      text: 'Is there any reason we wouldn\'t win your business?',
    }]
  },{
    id: '6',
    name: 'When will decision be made?',
    summaryQuestion: 'Summarize timeline',
    tasks: [{
      id: '611',
      imperative: '6',
      text: 'Decision date confirmed?',
    },{
      id: '612',
      imperative: '6',
      text: 'Legal and procurement engaged?',
    },{
      id: '613',
      imperative: '6',
      text: 'Project Kickoff date agreed?',
    },{
      id: '614',
      imperative: '6',
      text: 'Prospect has identified Kickoff Team?',
    },{
      id: '615',
      imperative: '6',
      text: 'Prospect is assisting in closing process?',
    }],
    questions: [{
      id: '621',
      text: 'When is the business counting on impact/ROI from this initiative? We need to sign and kickoff by _____ date to realize?',
    },{
      id: '622',
      text: 'How can we be helpful in facilitating your procurement process?',
    },{
      id: '623',
      text: 'We both have a number of moving parts at each of our respective organizations. Can we create a schedule of steps and dates so that we can keep the legal and procurement teams moving?',
    }]
  },{
    id: '7',
    name: 'What have we taught them?',
    summaryQuestion: 'Summarize teachings',
    tasks: [{
      id: '711',
      imperative: '7',
      text: 'I have developed rapport and credibility with Prospect?',
    },{
      id: '712',
      imperative: '7',
      text: 'I have a deep understanding of my Prospect’s challenges?',
    },{
      id: '713',
      imperative: '7',
      text: 'My Prospect believes we can meet their base expectations?',
    },{
      id: '714',
      imperative: '7',
      text: 'My Prospect has called to seek my guidance and counsel?',
    },{
      id: '715',
      imperative: '7',
      text: 'I believe if asked, my Prospect would say the sales process was so effective they would have paid for our counsel?',
    }],
    questions: [{
      id: '721',
      text: 'People buy from those they trust, like and learn from.',
    },{
      id: '722',
      text: 'Prospects must feel listened to.',
    },{
      id: '723',
      text: 'Core needs must be met before you can move to advisory selling.',
    },{
      id: '724',
      text: 'Be an expert in your field or craft.',
    },{
      id: '725',
      text: 'Position your company’s subject matter experts to add value.',
    },{
      id: '726',
      text: 'Practice your story selling skills.'
    }]
  }
];

export const imperativesStages = {
  stages: [{
    label: 'Qualify',
    value: 'qualify'
  },{
    label: 'Discovery',
    value: 'discovery'
  },{
    label: 'Alliance',
    value: 'alliance'
  },{
    label: 'Close',
    value: 'close'
  }],

  objectives: [{
    id: '101',
    stage: 'qualify',
    imperativeId: null,
    text: 'Initial call and discovery'
  },{
    id: '102',
    stage: 'qualify',
    imperativeId: null,
    text: 'Basic understanding of customer situation - needs and opportunities'
  },{
    id: '103',
    stage: 'qualify',
    imperativeId: null,
    text: 'Build rapport'
  },{
    id: '104',
    stage: 'discovery',
    imperativeId: null,
    text: 'Deep understanding of prospect’s needs, pain points and organization'
  },{
    id: '105',
    stage: 'discovery',
    imperativeId: null,
    text: 'Establish credibility of company and solution'
  },{
    id: '106',
    stage: 'discovery',
    imperativeId: null,
    text: 'Create enthusiasm for ongoing prospect engagement'
  },{
    id: '107',
    stage: 'discovery',
    imperativeId: null,
    text: 'Establish business imperatives for the partnership'
  },{
    id: '108',
    stage: 'alliance',
    imperativeId: '1',
    text: 'I1: Who is the Buyer?',
  },{
    id: '109',
    stage: 'alliance',
    imperativeId: '2',
    text: 'I2: Who are the Influencers?',
  },{
    id: '110',
    stage: 'alliance',
    imperativeId: '3',
    text: 'I3: Who are we competing against and why?',
  },{
    id: '111',
    stage: 'alliance',
    imperativeId: '4',
    text: 'I4: Why will we win?',
  },{
    id: '112',
    stage: 'alliance',
    imperativeId: '5',
    text: 'I5: Why will we lose?',
  },{
    id: '113',
    stage: 'alliance',
    imperativeId: '6',
    text: 'I6: When will decision be made?',
  },{
    id: '114',
    stage: 'alliance',
    imperativeId: '7',
    text: 'I7: What have we taught them?',
  },{
    id: '115',
    stage: 'alliance',
    imperativeId: null,
    text: 'Proposal presented',
  },{
    id: '116',
    stage: 'close',
    imperativeId: null,
    imperativeTaskId: '612',
    text: 'Legal and procurement engaged'
  },{
    id: '117',
    stage: 'close',
    imperativeId: null,
    text: 'Terms and fees negotiated'
  },{
    id: '118',
    stage: 'close',
    imperativeId: null,
    text: 'Contract signed'
  }],

  reciprocations: [{
    id: '201',
    stage: 'qualify',
    imperativeTaskId: null,
    text: 'Confirms interest and agrees to next step'
  },{
    id: '202',
    stage: 'qualify',
    imperativeTaskId: null,
    text: 'Shares current situation'
  },{
    id: '203',
    stage: 'discovery',
    imperativeTaskId: '112',
    text: 'Shares organizational goals and pain points'
  },{
    id: '204',
    stage: 'discovery',
    imperativeTaskId: '113',
    text: 'Confirms initiative and budget'
  },{
    id: '205',
    stage: 'discovery',
    //imperativeTaskId: '211',
    imperativeTaskId: null,
    text: 'Shares names and roles of key influencers'
  },{
    id: '206',
    stage: 'discovery',
    imperativeTaskId: '415',
    text: 'Shares buying-decision-making process'
  },{
    id: '207',
    stage: 'discovery',
    imperativeTaskId: '111',
    text: 'Confirms buyer'
  },{
    id: '208',
    stage: 'alliance',
    imperativeTaskId: '215',
    text: 'Key influencer or buyer becomes an advisor'
  },{
    id: '209',
    stage: 'alliance',
    imperativeTaskId: null,
    text: 'Provides business data to co-develop ROI/Value Proposition'
  },{
    id: '210',
    stage: 'alliance',
    imperativeTaskId: '212',
    text: 'Gives access to all influencers'
  },{
    id: '211',
    stage: 'alliance',
    imperativeTaskId: '115',
    text: 'Gives access to buyer'
  },{
    id: '212',
    stage: 'alliance',
    imperativeTaskId: null,
    text: 'Shares alternatives being considered'
  },{
    id: '213',
    stage: 'alliance',
    imperativeTaskId: '413',
    text: 'Shares win strategy'
  },{
    id: '214',
    stage: 'alliance',
    imperativeTaskId: null,
    text: 'Verbal commitment to close'
  },{
    id: '215',
    stage: 'close',
    imperativeTaskId: null,
    text: 'Assistance in completing closing docs'
  },{
    id: '216',
    stage: 'close',
    imperativeTaskId: null,
    text: 'Access to all legal and procurement staff'
  }/*,{
    id: '217',
    stage: 'close',
    imperativeTaskId: null,
    text: 'Kickoff date identified'
  }*/,{
    id: '218',
    stage: 'close',
    imperativeTaskId: '613',
    text: 'Kickoff date agreed'
  }]
}



// WEBPACK FOOTER //
// ./src/data/imperatives.js